module.exports = __webpack_public_path__ + "static/media/alcon.54760914.jpg";